import { Dialog, Grid, Box, Typography } from "@mui/material";
import Button from "@/components/ph/Button";

const InsuranceModal = ({
  open,
  onClose,
  title,
  message,
  buttonLabel = "Aceptar",
  onButtonClick
}) => {
  
  const handleButtonClick = async () => {
    if (onButtonClick) {
      await onButtonClick();
    } else {
      await onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Grid container spacing={2} sx={{ p: { xs: 2, md: 3 }, maxWidth: 500 }}>
        
        <Grid size={{ xs: 12 }}>
          <Typography sx={{ textAlign: "center", fontWeight: 400, fontSize: { xs: "1.4rem", md: "1.5rem" } }}>
            {title}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Typography sx={{ textAlign: "center", fontSize: { xs: "1rem", md: "1rem" }, lineHeight: 1.6 }}>
            {message}
          </Typography>
        </Grid>

        <Grid container size={{ xs: 12 }} sx={{ mt: 2 }} spacing={2} justifyContent="center" alignItems="center">
          
          <Grid size={{ xs: 12 }}>
            <Button label={buttonLabel} onClick={handleButtonClick} variant="black" />
          </Grid>

          <Grid size={{ xs: 12 }}>
            {/* Directamente el onClose del padre */}
            <Button label="Cerrar" onClick={onClose} variant="white" />
          </Grid>
          
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default InsuranceModal;
